<template>
  <div class="px-5 pt-5" style="min-height:100vh">
    <v-row style="min-height:100vh">
      <v-col cols="2"></v-col>
      <v-col cols="8">
        <v-data-table
          :headers="tabella.headers"
          :items="tabella.items"
          style="border-radius: 10px;"
          class="elevation-2"
        >
          <template v-slot:top>
            <v-toolbar
              style="border-radius: 10px 10px 0px 0px"
              color="indigo"
              dense
            >
              <v-toolbar-title class="white--text"> Layout </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-on="on"
                    @click="aggiungiRecord()"
                    v-bind="attrs"
                  >
                    <v-icon color="primary">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Aggiungi Layout</span>
              </v-tooltip>
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-on="on" @click="salvaLayouts()" v-bind="attrs">
                    <v-icon color="success">mdi-floppy</v-icon>
                  </v-btn>
                </template>
                <span>Salva Layout</span>
              </v-tooltip>

              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.layout_name`]="{ item }">
            <v-text-field
              class="pt-4"
              outlined
              v-model="item.layout_name"
              label="File name"
              dense
            ></v-text-field>
          </template>
          <template v-slot:[`item.upload`]="{ item }">
            <v-btn @click="uploadLayout(item)"><v-icon color="primary">mdi-upload</v-icon></v-btn>
          </template>
          <template v-slot:[`item.elimina`]="{ item }">
            <v-btn @click="deleteItem(item)"><v-icon color="error">mdi-delete</v-icon></v-btn>
          </template>
        </v-data-table>
      </v-col>

      <v-col cols="2"></v-col>
    </v-row>
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import newLayout from "@/classes/Layout.js";
export default {
  name: "Layout",
  components: {
    SnackbarQV,
  },
  data() {
    return {
      obj_layout: Object.assign({}, new newLayout()),
      tabella: {
        headers: [
          { text: "Layout", value: "layout_name", align: "center" },
          { text: "Upload", value: "upload", align: "center" },
          { text: "Elimina", value: "elimina" },
        ],
        items: [],
      },
    };
  },
  methods: {
    aggiungiRecord() {
      let obj = Object.assign({}, new newLayout());
      console.log("obj", obj);
      this.tabella.items.push(obj);
    },
    deleteItem(item){
        let indice = this.tabella.items.indexOf(item);
        this.tabella.items[indice].validita = 1;
    },
    uploadLayout(item) {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", ".lm1");
      input.onchange = function () {
        const reader = new FileReader();
        reader.onload = function () {
          const result = reader.result;
          const index = result.indexOf(";base64,") + 8;
          const parsed_result = result.substring(index);
          item.file = parsed_result;
        };
        reader.readAsDataURL(input.files[0]);
      };
      input.click();
    },
    getLayouts() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlayouts",
          token: localStorage.user_token,
        },
      };
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.tabella.items = res.data.result;
          } else {
            this.pz_per_scatola = null;
            this.$refs.SnackbarQV.print(
              "orange",
              `Errore nella comunicazione col server, codice ${res.status}.`
            );
          }
        })
        .catch(() => {
          this.pz_per_scatola = null;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server."
          );
        });
    },
  },
  mounted() {
    //this.getLayouts();
  },
};
</script>